import { createFileRoute, redirect } from "@tanstack/react-router";
import { splitSlug } from "@/lib/utils";

export const Route = createFileRoute("/novel/$slug/chapter/$chapterSlug")({
  loader: async ({ params }) => {
    const novelParts = splitSlug(params.slug);
    const chapterParts = splitSlug(params.chapterSlug);
    
    if (novelParts.id && novelParts.slug && chapterParts.id && chapterParts.slug) {
      throw redirect({
        to: "/novel/$id/$slug/chapter/$chapterId/$chapterSlug",
        params: { 
          id: novelParts.id, 
          slug: novelParts.slug,
          chapterId: chapterParts.id,
          chapterSlug: chapterParts.slug
        },
      });
    }
  },
});
